import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import {
  heroChartBarSquare,
  heroCog6Tooth,
  heroCreditCard,
  heroIdentification,
  heroKey,
  heroShieldCheck,
  heroUserGroup,
  heroUsers,
} from '@ng-icons/heroicons/outline';
import { SETTINGS_MODULES } from '../../core/navigation/app-modules';
import { UiModuleSidebar, type UiModuleSidebarItem } from '../../shared/ui';

@Component({
  selector: 'app-settings-page',
  imports: [RouterOutlet, UiModuleSidebar],
  providers: [
    provideIcons({
      heroChartBarSquare,
      heroCog6Tooth,
      heroCreditCard,
      heroIdentification,
      heroKey,
      heroShieldCheck,
      heroUserGroup,
      heroUsers,
    }),
  ],
  templateUrl: './settings.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsPage {
  readonly settingsItems = SETTINGS_MODULES;
  readonly settingsPathPrefix = '/configuracoes/';
  readonly navItems: readonly UiModuleSidebarItem[] = this.settingsItems.map((item) => ({
    id: item.path,
    label: item.label,
    route: item.path.slice(this.settingsPathPrefix.length),
    icon: item.icon,
    exact: item.exact,
  }));
}
